import React, { useState } from "react";
import "antd/dist/antd.css";
import { Upload, message } from 'antd';
import './MultiImageUpload.scss'
import { useTranslation } from "react-i18next";
import ImageUpload from '../ImageUpload/ImageUpload';

export default function MultiImageUpload(props) {
    const {t} = useTranslation();

	const [fileList, setFileList] = useState([]);
	const [filePreviewList, setFilePreviewList] = useState([]);

    const [fileListOD_D, setFileListOD_D] = useState([]);
    const [filePreviewOD_D, setFilePreviewOD_D] = useState('');
    const [fileListOD_M, setFileListOD_M] = useState([]);
    const [filePreviewOD_M, setFilePreviewOD_M] = useState('');
    const [fileListOS_D, setFileListOS_D] = useState([]);
    const [filePreviewOS_D, setFilePreviewOS_D] = useState('');
    const [fileListOS_M, setFileListOS_M] = useState([]);
    const [filePreviewOS_M, setFilePreviewOS_M] = useState('');

    const [isLoadingOD_D, setIsLoadingOD_D] = useState(false);
    const [isLoadingOD_M, setIsLoadingOD_M] = useState(false);
    const [isLoadingOS_D, setIsLoadingOS_D] = useState(false);
    const [isLoadingOS_M, setIsLoadingOS_M] = useState(false);

    const setFileListRightDisc = (fl) => {
        setFileListOD_D(fl);
        if (fl.length > 0) {
            let arr = fileList.filter(x => x.name !== fl[0].name);
            let file = fl[0];
            file.typeSide = 'right';
            file.typeEye = 'OD_D';
            arr.push(file);
            setFileList(arr);
        }
    }

    const setFileListRightMacula = (fl) => {
        setFileListOD_M(fl);
        if (fl.length > 0) {
            let arr = fileList.filter(x => x.name !== fl[0].name);
            let file = fl[0];
            file.typeSide = 'right';
            file.typeEye = 'OD_M';
            arr.push(file);
            setFileList(arr);
        }
    }

    const setFileListLeftDisc = (fl) => {
        setFileListOS_D(fl);
        if (fl.length > 0) {
            let arr = fileList.filter(x => x.name !== fl[0].name);
            let file = fl[0];
            file.typeSide = 'left';
            file.typeEye = 'OS_D';
            arr.push(file);
            setFileList(arr);
        }
    }

    const setFileListLeftMacula = (fl) => {
        setFileListOS_M(fl);
        if (fl.length > 0) {
            let arr = fileList.filter(x => x.name !== fl[0].name);
            let file = fl[0];
            file.typeSide = 'right';
            file.typeEye = 'OS_M';
            arr.push(file);
            setFileList(arr);
        }
    }

	const getBase64 = function (img, callback) {
		const reader = new FileReader();
		reader.addEventListener('load', () => callback(reader.result));
		reader.readAsDataURL(img);
	}

	const onFileRemoved = (file) => {
	    props.onFileRemoved(file);

		setFileList(fileList.filter(x => x.name !== file.name));
		//setFilePreviewList(filePreviewList.filter(x => x.fileName !== file.name));

	}

	const onFileUpload = (file) => {
        props.onFileUpload(file);
    }

	const handleChange = info => {

        const isAdded = addFileData(info.file.name, info.file);

        if (!info.file.status || isAdded) { //Intercepted file by beforeUpload don't have status field.
			return;
		}

        //setFileList(info.fileList);

	    if (fileList.length !== 4) {
	        return;
	    }

        let fl = [...fileList];

		fl = fl.map(file => {

            if(file.isUpload !== true) {

                props.setReferenceValue(file.referenceId);

                if (file.status === 'uploading') {
                    setEyeLoading(file.typeEye,true);
                }

                if (file.status === 'done') {
                    setEyeLoading(file.typeEye,false);
                    props.onFileUpload({side: file.typeSide, file: file.originFileObj, checkResult: file.response});
                    file.isUpload = true;
                }

                if (file.status === 'error') {
                    setEyeLoading(file.typeEye,false);
                    message.error('Failed to upload file');
                }

                if (file.response) {
                    file.checkResult = file.response;
                    file.originalFile = file.originFileObj;
                    getBase64(file.originFileObj, imageUrl => {
                        setEyePreview(file.typeEye,imageUrl);

                        let arr = [...filePreviewList];
                        let p = {
                            typeEye: file.typeEye,
                            preview: imageUrl,
                            fileName: file.name};
                        arr.push(p);
                        setFilePreviewList(arr);

                        props.onPreviewLoad(imageUrl);
                    })
                }

                let fl1 = [];
                fl1.push(file);
                setEyeFileList(file.typeEye,fl1);
    	    }

			return file;
		});

		setFileList(fl);

	};

    const setEyePreview = (typeEye, imageUrl) => {
        switch(typeEye.toUpperCase()) {
            case 'OD_D':
                setFilePreviewOD_D(imageUrl);
                break;
            case 'OS_D':
                setFilePreviewOS_D(imageUrl);
                break;
            case 'OD_M':
                setFilePreviewOD_M(imageUrl);
                break;
            case 'OS_M':
                setFilePreviewOS_M(imageUrl);
                break;
            default:
                break;
        }
    };

    const setEyeLoading = (typeEye, isEyeLoading) => {

        switch(typeEye) {
            case 'OD_D':
                setIsLoadingOD_D(isEyeLoading);
                break;
            case 'OS_D':
                setIsLoadingOS_D(isEyeLoading);
                break;
            case 'OD_M':
                setIsLoadingOD_M(isEyeLoading);
                break;
            case 'OS_M':
                setIsLoadingOS_M(isEyeLoading);
                break;
            default:
                break;
        }
    };

    const setEyeFileList = (typeEye, fl) => {
        switch(typeEye) {
            case 'OD_D':
                setFileListOD_D(fl);
                break;
            case 'OS_D':
                setFileListOS_D(fl);
                break;
            case 'OD_M':
                setFileListOD_M(fl);
                break;
            case 'OS_M':
                setFileListOS_M(fl);
                break;
            default:
                break;
        }
    }

	const beforeUpload = function (fileToUpload) {

        props.checkSessionExpired();

		const isJpgOrPng = fileToUpload.type === 'image/jpeg' || fileToUpload.type === 'image/png';
		if (!isJpgOrPng) {
			message.error('You can only upload JPG/PNG file!');
			return false;
		}

		const isLt5M = fileToUpload.size / 1024 / 1024 < 5;
		if (!isLt5M) {
			message.error('Image must smaller than 5MB!');
			return false;
		}

        if(fileList.length >= 4){
            let fl = fileList.slice(0,4);
            setFileList(fl);
            return false;
        }

	}

    const parseFileName = function(fileName) {
        /* template parse: [pat_number]_[R or L]_[datePhoto]_[timePhoto]_[text] */
        let splitName = fileName.split("_");

        if(splitName.length < 5 ) {
            message.error("The file '" + fileName
                + "' does not match the template '[pat_number]_[R or L]_[datePhoto]_[timePhoto]_[text]'");
            return false;
        }

        const datePhoto = parseInt(splitName[2], 10);
        const timePhoto = parseInt(splitName[3], 10);
        let typeSide = '';
        let typeEye = '';

        if (splitName[1].toLowerCase() === 'R'.toLowerCase()) {
            typeEye = 'OD_M';
            typeSide = 'right';
        } else {
            typeEye = 'OS_M';
            typeSide = 'left';
        }

        return {
                fileName: fileName,
                referenceId: splitName[0],
                datePhoto: datePhoto,
                timePhoto: timePhoto,
                typeEye: typeEye,
                typeSide: typeSide
        }
    }

    const addFileData = function(fileName, fileToUpload) {
        /* template parse: [pat_number]_[R or L]_[datePhoto]_[timePhoto]_[text] */
        let dataParsing = parseFileName(fileName);

        if(dataParsing === false) {
            return false;
        }
        if(dataParsing.typeSide === 'right' && !hasNotUploadedRightEye()) {return false;}
        if(dataParsing.typeSide === 'left' && !hasNotUploadedLeftEye()) {return false;}

        for ( let i = 0; i < fileList.length; i++ ) {
            if (fileList[i].name === fileName) {
                return false;
            }
        }

        let b = true;

        if (b && dataParsing.typeSide === 'right' && hasNotEmptyOD_D && !hasNotEmptyOD_M()) {
            b = false;
            dataParsing.typeEye = 'OD_D';
        }

        if (b && dataParsing.typeSide === 'right' && !hasNotEmptyOD_D() && hasNotEmptyOD_M()) {
            b = false;
            dataParsing.typeEye = 'OD_M';
        }

        if (b && dataParsing.typeSide === 'left' && hasNotEmptyOS_D() && !hasNotEmptyOS_M()) {
            b = false;
            dataParsing.typeEye = 'OS_D';
        }

        if (b && dataParsing.typeSide === 'left' && !hasNotEmptyOS_D() && hasNotEmptyOS_M()) {
            b = false;
            dataParsing.typeEye = 'OS_M';
        }

        if (b && fileList.length > 0) {

            const f = fileList.map(file => {

                if (file.typeSide === dataParsing.typeSide) {
                    if (file.timePhoto > dataParsing.timePhoto) {
                        if (dataParsing.typeSide === 'right') {
                            file.typeEye = 'OD_D';
                        } else {
                            file.typeEye = 'OS_D';
                        }
                    } else {
                        if (dataParsing.typeSide === 'right') {
                            dataParsing.typeEye = 'OD_D';
                            file.typeEye = 'OD_M';
                        } else {
                            dataParsing.typeEye = 'OS_D';
                            file.typeEye = 'OS_M';
                        }
                    }
                }
                return file;
            });

            setFileList(f);
        }

        let ff = [...fileList];
        fileToUpload.referenceId = dataParsing.referenceId;
        fileToUpload.datePhoto = dataParsing.datePhoto;
        fileToUpload.timePhoto = dataParsing.timePhoto;
        fileToUpload.typeEye = dataParsing.typeEye;
        fileToUpload.typeSide = dataParsing.typeSide;
        ff.push(fileToUpload);

        setFileList(ff);
    }

    const hasNotUploadedLeftEye = () => {
        if (fileListOS_D.length > 0
                && fileListOS_M.length > 0) {
            return false;
        }
        return true;
    }

    const hasNotUploadedRightEye = () => {
        if (fileListOD_D.length > 0
                && fileListOD_M.length > 0) {
            return false;
        }
        return true;
    }

    const hasNotEmptyOD_M = () => {
        if (fileListOD_M.length > 0) {
            return false;
        }
        return true;
    }

    const hasNotEmptyOD_D = () => {
        if (fileListOD_D.length > 0) {
            return false;
        }
        return true;
    }

    const hasNotEmptyOS_M = () => {
        if (fileListOS_M.length > 0) {
            return false;
        }
        return true;
    }

    const hasNotEmptyOS_D = () => {
        if (fileListOS_D.length > 0) {
            return false;
        }
        return true;
    }

    return (
		<div>
			<div className="image-uploads">
                <div>
                    <h2>{t('common.OD')}</h2>
                    <div className="eye-upload">
                            <ImageUpload
                                    checkSessionExpired={props.checkSessionExpired}
                                    onPreviewLoad={props.onPreviewLoad}
                                    isLoading={isLoadingOD_M}
                                    setIsLoading={setIsLoadingOD_M}
                                    fileList={fileListOD_M}
                                    setFileList={setFileListRightMacula}
                                    filePreview={filePreviewOD_M}
                                    setFilePreview={setFilePreviewOD_M}
                                    onFileRemoved={onFileRemoved}
                                    onFileUpload={onFileUpload}
                                    beforeUpload={beforeUpload}
                                    overlayKey="od-m"
                                    label={t('upload.imageLeftEyeMacula')} side="right" />
                            <ImageUpload
                                    checkSessionExpired={props.checkSessionExpired}
                                    onPreviewLoad={props.onPreviewLoad}
                                    isLoading={isLoadingOD_D}
                                    setIsLoading={setIsLoadingOD_D}
                                    fileList={fileListOD_D}
                                    setFileList={setFileListRightDisc}
                                    filePreview={filePreviewOD_D}
                                    setFilePreview={setFilePreviewOD_D}
                                    onFileRemoved={onFileRemoved}
                                    onFileUpload={onFileUpload}
                                    beforeUpload={beforeUpload}
                                    overlayKey="od-d"
                                    label={t('upload.imageLeftEyeDisc')} side="right" />
                        </div>
                </div>
                        <div>
                            <h2>{t('common.OS')}</h2>
                            <div className="eye-upload">
                                <ImageUpload
                                    checkSessionExpired={props.checkSessionExpired}
                                    onPreviewLoad={props.onPreviewLoad}
                                    isLoading={isLoadingOS_M}
                                    setIsLoading={setIsLoadingOS_M}
                                    fileList={fileListOS_M}
                                    setFileList={setFileListLeftMacula}
                                    filePreview={filePreviewOS_M}
                                    setFilePreview={setFilePreviewOS_M}
                                    onFileRemoved={onFileRemoved}
                                    onFileUpload={onFileUpload}
                                    beforeUpload={beforeUpload}
                                    overlayKey="os-m"
                                    label={t('upload.imageRightEyeMacula')} side="left" />
                                <ImageUpload
                                    checkSessionExpired={props.checkSessionExpired}
                                    onPreviewLoad={props.onPreviewLoad}
                                    isLoading={isLoadingOS_D}
                                    setIsLoading={setIsLoadingOS_D}
                                    fileList={fileListOS_D}
                                    setFileList={setFileListLeftDisc}
                                    filePreview={filePreviewOS_D}
                                    setFilePreview={setFilePreviewOS_D}
                                    onFileRemoved={onFileRemoved}
                                    onFileUpload={onFileUpload}
                                    beforeUpload={beforeUpload}
                                    overlayKey="os-d"
                                    label={t('upload.imageRightEyeDisc')} side="left" />
                            </div>
                        </div>
                	</div>

        	<Upload
        	    id="id-multi-upload-zone"
        	    className="multi-upload-zone"
                accept="image/png, image/jpeg"
                name="image"
                action="/api/checkImage"
				multiple
				beforeUpload={beforeUpload}
				onChange={handleChange}
				listType="picture-card"
				fileList={fileList}
				showUploadList={false}
				>
                <p className="ant-upload-text">Click or drag file to this area to upload</p>
                <p className="ant-upload-hint">( Selected {fileList.length} of 4 )</p>
			</Upload>
		</div>
	)
}